import { GetApiUploadedFilesApiResponse } from "src/app/services/api.generated";
import { ColumnModes, ColumnType } from "src/types/genericTable.types";
import { ActionButtonModes } from "src/types/actionButton.types";
import { ActionModes } from "src/types/actionItems.types";
import theme from "src/configs/theme/theme";

const colors = new Map<string, string>([
  ["ناتمام", theme.palette.warning.light],
  ["تکمیل شده", theme.palette.success.main],
]);

export const UploadedFilesData: ColumnType<GetApiUploadedFilesApiResponse>[] = [
  {
    type: ColumnModes.DATA,
    id: "file_metadata",
    label: "نام فایل",
    chip: false,
    color: "",
  },
  {
    type: ColumnModes.DATA,
    id: "file_size",
    label: "حجم فایل",
    chip: false,
    color: "",
  },
  {
    type: ColumnModes.DATA,
    id: "file_status",
    label: "وضعیت فایل",
    chip: true,
    color: colors,
  },
  {
    type: ColumnModes.ACTION,
    label: "عملیات",
    actions: [
      {
        type: ActionButtonModes.SINGLE,
        color: theme.palette.primary.light,
        label: "فایل های تبدیل شده",
        action: {
          type: ActionModes.REDIRECT,
          props: ["tus_file_id"],
          to: ({ tus_file_id }) => `/files/converted-files/${tus_file_id}`,
        },
      },
    ],
  },
    {
    type: ColumnModes.DATA,
    id: "channelTitle",
    label: "دسته بندی",
    chip: false,
    color: colors,
  },
];
